export default "__VITE_ASSET__e5AuE3tS__"